import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChapterPage } from './chapter';

const routes: Routes = [
  {
    path: '',
    component: ChapterPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChapterPageRoutingModule { }
